import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", {
  for: "search-dropdown",
  class: "mb-2 text-sm font-medium text-gray-900 sr-only dark:text-white"
}, null, -1)
const _hoisted_3 = {
  id: "dropdown-button",
  "data-dropdown-toggle": "dropdown",
  class: "flex-shrink-0 z-10 inline-flex items-center py-2.5 px-4 text-sm font-medium text-center text-gray-900 bg-gray-100 border border-gray-300 rounded-l-lg hover:bg-gray-200 focus:ring-4 focus:outline-none focus:ring-gray-100 dark:bg-gray-700 dark:hover:bg-gray-600 dark:focus:ring-gray-700 dark:text-white dark:border-gray-600",
  type: "button"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("svg", {
  class: "w-2.5 h-2.5 ml-2.5",
  "aria-hidden": "true",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 10 6"
}, null, -1)
const _hoisted_5 = { class: "relative w-full" }
const _hoisted_6 = ["value", "placeholder"]

import { onMounted,ref } from 'vue'
import { initFlowbite } from 'flowbite'


export default /*#__PURE__*/_defineComponent({
  __name: 'SearchBox',
  props: {
  searchWhat: String,
  page: String,
  items: Array,
  modelValue: String,

},
  emits: ["filter"],
  setup(__props, { emit }) {

const props = __props;

onMounted(() => {
  initFlowbite();
})




// function selectPage(selectedPage){
//   emit('update:page', selectedPage);
// }


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("button", _hoisted_3, [
        _createTextVNode(_toDisplayString(__props.page), 1),
        _hoisted_4
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("input", {
          onKeypress: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('filter'))),
          value: __props.modelValue,
          onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:modelValue', $event.target.value))),
          type: "search",
          id: "search-dropdown",
          class: "block p-2.5 w-full z-20 text-sm text-gray-900 bg-gray-50 rounded-r-lg border-l-gray-50 border-l-2 border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-l-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:border-blue-500",
          placeholder: __props.searchWhat,
          required: ""
        }, null, 40, _hoisted_6)
      ])
    ])
  ]))
}
}

})